import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import CountUp from "react-countup";
import "bootstrap-daterangepicker/daterangepicker.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Cookies from "js-cookie";
import { motion, Variants } from "framer-motion";
import LogoSpinnerInline from "../../../academic/examinations/spinner";
import { all_routes } from "../../../router/all_routes";
import { useUserPermissions } from "../../../UserPermissionsContext";
import { InactivityContext } from "../InactivityContext";
import ImageWithBasePath from "../../../../core/common/imageWithBasePath";
import Cards from "./Cards";
import WeeklySaleschart from "./WeeklySaleschart";
import BranchClassWiseSales from "./BranchClassWiseSales";
import BranchClassWiseETS from "./BranchClassWiseETS";
import SalesTrend from "./salesTrend";
import RevenueTrend from "./RevenueTrend";

export type Option = {
  value: string;
  label: string;
};

type TodayLeads = {
  total_leads: number;
  call_logs: number;
  connected_call_logs: number;
  interested: number;
  call_backs: number;
  sales: number;
  average_conversation_duration: string;
  "call/leads_per": number;
  calls_connected_per: number;
  interested_per: number;
  call_backs_per: number;
  sales_per: number;
  not_interested: number;
  not_interested_per: number;
  achieved_amount: string;
  target_amount: string;
  target_amount_per: number;
  weekly_sales_target: number;
  weekly_sales_achieved: number;
  weekly_sales_achieved_percentage: number;
  target_conversation_time: any;
  conversation_time: any;
  conversation_efficiency: number;
  total_calls: number;
  connected_calls: number;
  call_connected_per: number;
  unique_leads_touch: number;
  unique_leads_connected: number;
  unique_leads_connected_per: number;
  total_sales: number;
  // sales_per:number;
};

const SEDDashBoard = () => {
  const routes = all_routes;
  const [photoLoading, setPhotoLoading] = useState(false);
  const { userPermissions, webApi, userData } = useUserPermissions();
  const jwtToken = Cookies.get("authToken");
  const [dateRangeLeads, setDateRangeLeads] = useState<TodayLeads | null>(null);
  const [DateRangeLeadsLoading, setDateRangeLeadsLoading] = useState(false);

  const cardVariants: Variants = {
    hidden: {
      opacity: 0,
      y: 30,
    },
    visible: (index: number) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: index * 0.1,
        duration: 0.5,
        ease: [0.25, 0.1, 0.25, 1], // ← cubic-bezier (easeOut)
      },
    }),
  };
  const [bgGradient, setBgGradient] = React.useState(
    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
  );

  const extractColor = (img: HTMLImageElement) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;
    ctx.drawImage(img, 0, 0);

    const { data } = ctx.getImageData(0, 0, canvas.width, canvas.height);

    let r = 0,
      g = 0,
      b = 0,
      count = 0;

    for (let i = 0; i < data.length; i += 4 * 20) {
      r += data[i];
      g += data[i + 1];
      b += data[i + 2];
      count++;
    }

    r = Math.floor(r / count);
    g = Math.floor(g / count);
    b = Math.floor(b / count);

    setBgGradient(
      `linear-gradient(135deg, rgb(${r},${g},${b}) 0%, rgba(${r},${g},${b},0.6) 100%)`,
    );
  };

  const inactivityContext = useContext(InactivityContext);
  if (!inactivityContext) {
    throw new Error("Header must be used within an InactivityProvider");
  }
  const { photo1 } = inactivityContext;

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";
  }, [isOpen]);

  useEffect(() => {
    const offcanvasEl = document.getElementById("offcanvasRight");

    const handleShow = () => setIsOpen(true);
    const handleHide = () => setIsOpen(false);

    if (offcanvasEl) {
      offcanvasEl.addEventListener("show.bs.offcanvas", handleShow);
      offcanvasEl.addEventListener("hide.bs.offcanvas", handleHide);
    }

    return () => {
      if (offcanvasEl) {
        offcanvasEl.removeEventListener("show.bs.offcanvas", handleShow);
        offcanvasEl.removeEventListener("hide.bs.offcanvas", handleHide);
      }
    };
  }, []);

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <>
            {/* Page Header */}
            <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
              <div className="my-auto mb-2">
                <h3 className="page-title mb-1">SED Dashboard</h3>
                {/* <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={routes.SEDDashBoard}>Dashboard</Link>
                    </li>
                    <li
                        className="breadcrumb-item active"
                        aria-current="page"
                    >
                      SED Dashboard
                    </li>
                  </ol>
                </nav> */}
              </div>
            </div>
            <div className="row">
              {photoLoading ? (
                <div
                  style={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <LogoSpinnerInline />
                </div>
              ) : (
                <div className="col-md-12 d-flex">
                  <div
                    className="card flex-fill"
                    style={{
                      background: bgGradient,
                      border: "none",
                      transition: "background 0.4s ease",
                    }}
                  >
                    <div className="card-body" style={{ position: "relative" }}>
                      <h1 className="text-white mb-1">
                        Welcome {userData?.username.toLowerCase()}
                      </h1>
                      <p className="text-white mb-3">Have a Good day at work</p>

                      <div
                        style={{
                          position: "absolute",
                          right: 0,
                          top: 0,
                          height: "100%",
                          aspectRatio: "56 / 56",
                          // minWidth: "150px",
                          maxWidth: "45%",
                          overflow: "hidden",
                          pointerEvents: "none",
                        }}
                      >
                        <img
                          src={photo1}
                          alt="User Profile"
                          crossOrigin="anonymous"
                          onLoad={(e) => extractColor(e.currentTarget)}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",

                            /* clarity */
                            filter:
                              "brightness(1.08) contrast(1.15) saturate(1.15)",

                            /* smooth blend */
                            WebkitMaskImage:
                              "linear-gradient(to left, rgba(0,0,0,1), rgba(0,0,0,0.7))",
                            maskImage:
                              "linear-gradient(to left, rgba(0,0,0,1), rgba(0,0,0,0))",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="row">
              {DateRangeLeadsLoading ? (
                <div
                  style={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <LogoSpinnerInline />
                </div>
              ) : (
                <Cards />
              )}
            </div>
            <div className="row pt-4">
              <WeeklySaleschart />
            </div>

            <div className="row pt-4">
              <div className="col-md-6 mb-3">
                <SalesTrend />
              </div>
              <div className="col-md-6 mb-3">
                <RevenueTrend/>
              </div>
            </div>

            <div className="row pt-4">
              <div className="col-md-6 mb-3">
                <BranchClassWiseSales />
              </div>

              <div className="col-md-6 mb-3">
                <BranchClassWiseETS />
              </div>
            </div>
          </>
        </div>
      </div>
    </>
  );
};

export default SEDDashBoard;
